import { styled } from 'baseui';

export const StyledStandardButton = styled('button', {});
